import { buildModelManager } from "../builder.js";
const DefaultAgentConversationSelection = {
  __typename: true,
  id: true,
  agentConfigurationId: true,
  agentType: true,
  averageResponseTime: true,
  backgroundProcessing: true,
  cohort: true,
  completedAt: true,
  conversationGoalAchieved: true,
  conversationId: true,
  conversationStatus: true,
  conversationTitle: true,
  createdAt: true,
  firstResponseId: true,
  flaggedForReview: true,
  hasFlaggedMessages: true,
  hasUserFeedback: true,
  institution: true,
  instructorNotified: true,
  isActive: true,
  lastActivityAt: true,
  lastResponseId: true,
  markedForTraining: true,
  messageCount: true,
  openaiConversationId: true,
  qualityScore: true,
  resolutionType: true,
  responseChain: true,
  reviewNotes: { markdown: true, truncatedHTML: true },
  reviewedAt: true,
  reviewedById: true,
  sessionMetadata: true,
  startedAt: true,
  totalCost: true,
  totalTokensUsed: true,
  trainingCategory: true,
  trainingNotes: true,
  updatedAt: true,
  userId: true,
  userSatisfactionRating: true
};
const modelApiIdentifier = "agentConversation";
const pluralModelApiIdentifier = "agentConversations";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAgentConversationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAgentConversationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentConversationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentConversationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentConversationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAgentConversationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAgentConversationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByConversationId",
    findByField: "conversationId",
    findByVariableName: "conversationId",
    modelApiIdentifier,
    defaultSelection: DefaultAgentConversationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByConversationId",
    findByField: "conversationId",
    findByVariableName: "conversationId",
    modelApiIdentifier,
    defaultSelection: DefaultAgentConversationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createAgentConversation",
    operationReturnType: "CreateAgentConversation",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      agentConversation: { required: false, type: "CreateAgentConversationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentConversationSelection
  },
  {
    type: "action",
    operationName: "bulkCreateAgentConversations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateAgentConversationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAgentConversationSelection
  },
  {
    type: "action",
    operationName: "updateAgentConversation",
    operationReturnType: "UpdateAgentConversation",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      agentConversation: { required: false, type: "UpdateAgentConversationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentConversationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateAgentConversations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateAgentConversationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAgentConversationSelection
  },
  {
    type: "action",
    operationName: "deleteAgentConversation",
    operationReturnType: "DeleteAgentConversation",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteAgentConversations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertAgentConversation",
    operationReturnType: "UpsertAgentConversation",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      agentConversation: { required: false, type: "UpsertAgentConversationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateAgentConversationResult": { hasReturnType: false },
      "... on UpdateAgentConversationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentConversationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertAgentConversations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertAgentConversationsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultAgentConversationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "agentConversationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AgentConversationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAgentConversationSelection,
  operations
);
export {
  AgentConversationManager,
  DefaultAgentConversationSelection
};
//# sourceMappingURL=AgentConversation.js.map
